import React, { Component, useEffect, useState } from "react";
import Slider from "./components/NetflixSlider";
import Axios from "axios";
import { Link } from "react-router-dom";
import { Avatar, Carousel } from "antd";
import { HeartTwoTone } from "@ant-design/icons";
import "./movie.scss";

const Movie = () => {
  const [movieList, setMovieList] = useState(null);
  useEffect(() => {
    Axios.get("https://backendexample.sanbersy.com/api/data-movie")
      .then((response) => {        
        setMovieList(response.data);
      })

      .catch((err) => {        
      });
  }, []);

  return (
    <div className="app" style={{ minHeight: "100vh" }}>
      <div className="hub">
        <h3>List All Movies</h3>
        {movieList ? (
          <Slider>
            {movieList.map((movie) => (
              <Slider.Item movie={movie} key={movie.id}>
                item1
              </Slider.Item>
            ))}
          </Slider>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Movie;
